// extracted by mini-css-extract-plugin
export var screen1 = "screen1-module--screen1--aa58f";
export var screen1__btn = "screen1-module--screen1__btn--5335d";
export var screen1__content = "screen1-module--screen1__content--835ac";
export var screen1__desc = "screen1-module--screen1__desc--fe378";
export var screen1__descBox = "screen1-module--screen1__desc-box--0b6d8";
export var screen1__subtitle = "screen1-module--screen1__subtitle--29149";
export var screen1__title = "screen1-module--screen1__title--12b46";